import { VALUATIONS_OTHER_LABEL } from 'common/constants/valuations';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { APPROACH_SELECTIONS_ALIASES } from 'pages/Valuations/util/constants';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';
import getSelectedApproach from './getSelectedApproach';
import { TableData } from './types';

const getOptionsAccordingApproach = (cell: ICell) => {
  // Read the same-column selector each time an editor/viewer renders, including unsaved panel IDs.
  const selector = Object.values(cell.sheet?.cells ?? {}).find(
    candidate =>
      candidate.columnLegend === cell.columnLegend &&
      candidate.alias !== undefined &&
      APPROACH_SELECTIONS_ALIASES.includes(candidate.alias)
  );
  if (!selector?.value) {
    return [VALUATIONS_OTHER_LABEL];
  }
  const tableData = cell.sheet?.tableData as TableData | undefined;
  const benchmark = getSelectedApproach({ approaches: tableData?.approaches, approachId: selector.value });
  return getSelectionCellOptions({
    isDCF: true,
    specificApproach: benchmark?.valuations_approach_gpc ?? benchmark?.valuations_approach_gpt,
  });
};

export default getOptionsAccordingApproach;
